import { MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STATIC_PAGES_NAMESPACE } from '../store/modules/static-pages/static-pages.store.js';
import { store } from '../store/index.js';
import { getPageContent } from '@gig/magic-sdk/dist/util/static-content';

var staticPages = namespace(STATIC_PAGES_NAMESPACE);
var StaticPageMixin = /** @class */ (function (_super) {
    __extends(StaticPageMixin, _super);
    function StaticPageMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StaticPageMixin.prototype.fetchPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchStaticPage({
                                slug: this.slug,
                                lang: this.magicConfig.language,
                            })];
                    case 1:
                        _a.sent();
                        this.onContentLoad(this.page);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.warn(e_1);
                        this.onContentNotFound();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StaticPageMixin.prototype, "page", {
        get: function () {
            return this.staticPage(this.slug, this.magicConfig.language);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPageMixin.prototype, "content", {
        get: function () {
            return getPageContent(this.page);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Emitted when page was successfully loaded
     */
    StaticPageMixin.prototype.onContentLoad = function (page) {
        return page;
    };
    /**
     * Emitted when no content is found
     */
    StaticPageMixin.prototype.onContentNotFound = function () {
        return;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageMixin.prototype, "slug", void 0);
    __decorate([
        staticPages.Action('fetchStaticPage'),
        __metadata("design:type", Function)
    ], StaticPageMixin.prototype, "fetchStaticPage", void 0);
    __decorate([
        staticPages.Getter('staticPage'),
        __metadata("design:type", Function)
    ], StaticPageMixin.prototype, "staticPage", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        Watch('slug'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], StaticPageMixin.prototype, "fetchPage", null);
    __decorate([
        Emit('contentLoad'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], StaticPageMixin.prototype, "onContentLoad", null);
    __decorate([
        Emit('contentNotFound'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StaticPageMixin.prototype, "onContentNotFound", null);
    StaticPageMixin = __decorate([
        Component({
            store: store,
        })
    ], StaticPageMixin);
    return StaticPageMixin;
}(Mixins(MagicConfigMixin, ContentMixin)));

export { StaticPageMixin };
